import { render, staticRenderFns } from "./RequiredResetPassword.vue?vue&type=template&id=af603b72&"
import script from "./RequiredResetPassword.vue?vue&type=script&lang=js&"
export * from "./RequiredResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports